import { Component, OnInit, Renderer2, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService, MenuItem } from "primeng/api";
import { ActivatedRoute } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { UserService } from "src/app/services/user.service";
import { KycService } from "src/app/services/kyc.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-bank-details",
  templateUrl: "./bank-details.component.html",
  styleUrls: ["./bank-details.component.scss"],
  providers: [ConfirmationService, MessageService, KycService],
})

export class AdminUserBankDetailsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  items: MenuItem[];
  id;
  public loggedInUser;
  public isLoggedIn: boolean;
  public userId;
  public panForm: FormGroup;
  public submitted: boolean;
  public showMessage: boolean = false;
  public isAcademy: boolean = false;
  bankDetails: any = [];
  userName : any;
  mobileNumber:Number

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private renderer: Renderer2,
    private kycService: KycService,
  ) { }
  async ngOnInit(): Promise<void> {
    this.userId = this.activatedRoute.snapshot.params.id;
    this.id = this.userId;
    this.getBankDetails(this.userId);
    this.getUserDetails(this.userId);
    this.renderer.addClass(document.body, 'kyc-page');
  }
  get f() {
    return this.panForm.controls;
  }
  async getBankDetails(userId) {
    let query = "filterByDisable=false&filterByStatus=true";
    this.kycService.getUserKycBankList(userId, query).pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.bankDetails = res?.items;
      },
      err => {
      }
    );
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.userName = data?.fullName;
        this.mobileNumber = data?.mobileNumber;
        //this.item = data;
      }, err => {
      });
  
    }

    ngOnDestroy() {
      this.renderer.removeClass(document.body, 'kyc-page');
      this.destroy$.next();
      this.destroy$.complete();
    }
  }
